import { RouteRecordRaw } from 'vue-router';

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/personal/HomeRoot.vue'),
    redirect: { name: 'Dashboard' },
    children: [],
  },
  {
    path: '/dashboard',
    name: 'DashboardRoot',
    component: () => import('@/pages/personal/DashboardRoot.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/pages/personal/PersonalDashboard.vue'),
      },
      {
        path: 'my-projects',
        name: 'MyProjects',
        component: () => import('@/pages/personal/MyProjects.vue'),
      },
      {
        path: 'tasks',
        name: 'DashboardTasks',
        component: () => import('@/pages/personal/PersonalDashboardTasks.vue'),
      },
    ],
  },
  {
    path: '/dashboard/project-reports',
    name: 'CompanyProjectReports',
    component: () => import('@/pages/company/CompanyProjectReportsPage.vue'),
  },
];
